var _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#FFFFFF",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#FFFFFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chevronDownIconTitle"
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "6 10 12 16 18 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.52f2476872b6545874a969cb38f3fb2c.svg";
export { ForwardRef as ReactComponent };